import React from 'react'

const Spinner = () => {
  return (
    <div className="loading-spinner"></div>
  );
};

export default Spinner;